module.exports = __webpack_public_path__ + "static/media/homeowner5-.c046fcde.png";